/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Section_BasicsInputs */



/**
* | output |
* | --- |
* | "Basics" |
*
* @param {Tfield_Section_BasicsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_section_basics = /** @type {((inputs?: Tfield_Section_BasicsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Section_BasicsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Général")
	if (locale === "es") return /** @type {LocalizedString} */ ("General")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Geral")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generale")
	return /** @type {LocalizedString} */ ("Basics")
});